import { render, staticRenderFns } from "./TheErrorModal.vue?vue&type=template&id=c48893d4&"
import script from "./TheErrorModal.vue?vue&type=script&lang=js&"
export * from "./TheErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports